import { buildManagePageQueryString } from "./helpers/buildManagePageQueryString";
import { jumboMediaAPI } from "./service";
import { CACHE_TTL } from "./cacheConfig";

/**
 * Service Packages manage page API
 */

export const servicePackagesAPI = jumboMediaAPI.injectEndpoints({
  endpoints: (build) => ({
    getServicePackages: build.query({
      query: (body) =>
        `/api/ClientServicePackages/DataTablesSource${buildManagePageQueryString(
          body.columns,
          body.page,
          body.searchTerm,
          (body.page - 1) * body.limit,
          body.limit,
          body.orderColumnIndex,
          body.isDescSortDir
        )}`,
    }),
    getAllServicePackages: build.query({
      query: () => ({
        url: `/api/ClientServicePackages/AdminGet`,
        method: "GET",
      }),
      providesTags: ["ServicePackages"],
      keepUnusedDataFor: CACHE_TTL.LOOKUP,
    }),
    createServicePackages: build.mutation({
      query: (body) => ({
        url: `/api/ClientServicePackages/AdminPost/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["ServicePackages"],
    }),
    updateServicePackages: build.mutation({
      query: (body) => {
        return {
          url: `/api/ClientServicePackages/AdminPut/${body.Id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["ServicePackages"],
    }),
    deleteServicePackages: build.mutation({
      query: (body) => ({
        url: `/api/ClientServicePackages/AdminDelete/${body.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ServicePackages"],
    }),
    getServicePackagesForClient: build.query({
      query: () => `api/ClientServicePackages/GetServicePackages`,
    }),
  }),
  
});

export const {
  useGetServicePackagesQuery,
  useCreateServicePackagesMutation,
  useDeleteServicePackagesMutation,
  useUpdateServicePackagesMutation,
  useGetAllServicePackagesQuery,
  useGetServicePackagesForClientQuery,
  useLazyGetServicePackagesForClientQuery,
} = servicePackagesAPI;
